import {Group, Paper, Stack, Text, ThemeIcon, Title} from '@mantine/core';
import type {ElementType, ReactNode} from 'react';
import classes from './NavCard.module.css';

/**
 * Clickable card that navigates to a route: icon, title, and short
 * description, with the whole card rendered as one anchor.
 * @registry Full-card navigation link with icon, title, and description.
 */
export interface NavCardProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  /** Link implementation (e.g. router `Link`); its props (`to`) pass through `...rest`. */
  component?: ElementType;
  [key: string]: unknown;
}

export const NavCard = ({
  title,
  description,
  icon,
  component = 'a',
  ...rest
}: NavCardProps) => (
  <Paper
    component={component as any}
    withBorder
    shadow="xs"
    p="md"
    className={classes.card}
    {...rest}>
    <Group gap="sm" align="flex-start" wrap="nowrap">
      {icon && (
        <ThemeIcon size="lg" variant="light" color="gray">
          {icon}
        </ThemeIcon>
      )}
      <Stack gap={4}>
        <Title order={5}>{title}</Title>
        {description && (
          <Text size="sm" c="dimmed">
            {description}
          </Text>
        )}
      </Stack>
    </Group>
  </Paper>
);
